import { useEffect, useState } from "react";
import {
  checkInstagramConnection,
  getInstagramMetrics,
  startInstagramConnect,
} from "services/instragram.service";
import InstagramMetrics from "./social/InstagramMetrics";
import { useAuth } from "providers/auth.provider";

interface RecentPost {
  id: string;
  imageUrl: string;
  caption: string;
  likes: number;
}

export interface MetricDetail {
  value: number;
  mom: number; // month-over-month %
  yoy: number; // year-over-year %
}

export interface Metrics {
  followers: MetricDetail;
  reach: MetricDetail;
  impressions: MetricDetail;
  engagement: MetricDetail;
  posts: MetricDetail;
}

export interface TopPost {
  id: string;
  thumbnail: string;
  likes: number;
  comments: number;
  saves: number;
  caption: string;
}

export interface InstagramAccount {
  id: string;
  username: string;
  name: string;
  profile_picture_url: string;
  metrics: Metrics;
  topPosts: TopPost[];
  insights: string[];
}

interface Props {
  userId: string;
}

export const InstagramDashboard = ({ userId }: Props) => {
  const { idToken } = useAuth();

  const [connected, setConnected] = useState<boolean | null>(false);
  const [metrics, setMetrics] = useState<InstagramAccount[] | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function init() {
      setLoading(true);
      try {
        const isConnected = await checkInstagramConnection(userId, idToken);
        console.log(isConnected);
        setConnected(isConnected);

        if (isConnected) {
          const data = await getInstagramMetrics(userId);
          setMetrics(data as any);
        }
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }
    init();
  }, [userId]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="text-red-500">{error}</p>;

  if (!connected)
    return (
      <button
        className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
        onClick={() => startInstagramConnect(userId, idToken)}
      >
        Connect Instagram
      </button>
    );

  return (
    <div>
      <InstagramMetrics graphAPIData={metrics} />
    </div>
  );
};
